/*
 * REMIND CUSTOM: department-menu
 * Vanilla web component for the mobile drawer's department tabs (e.g. Women / Men).
 * - Tabs switch the visible category panel IN PLACE (no page reload).
 * - The active department is remembered in a cookie, so the menu stays consistent
 *   across pages without relying on per-collection metafields.
 * - Navigation to a department's main page happens via that menu's own "Shop all"
 *   link (a normal link inside the panel), which the theme prefetches on its own.
 * - No Section Rendering API / AJAX -> immune to the "null" submenu bug in ROAR 5.3.3.
 * Isolated on purpose (own customElements.define) so ROAR theme updates never touch it.
 */
(function () {
  var COOKIE = 'remind_dept';
  var MAX_AGE = 60 * 60 * 24 * 30; // 30 days

  function getCookie(name) {
    var match = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return match ? decodeURIComponent(match[1]) : '';
  }

  function setCookie(name, value) {
    document.cookie =
      name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + MAX_AGE + '; SameSite=Lax';
  }

  if (customElements.get('remind-department-menu')) return;

  customElements.define(
    'remind-department-menu',
    class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.prototype.slice.call(this.querySelectorAll('[data-dept]'));
        this.panels = Array.prototype.slice.call(this.querySelectorAll('[data-dept-panel]'));

        var fallback =
          this.dataset.default || (this.tabs[0] && this.tabs[0].dataset.dept) || '';
        // Restore the shopper's last choice, else the default department (Women).
        var active = getCookie(COOKIE) || fallback;

        this.select(active, false);

        this.tabs.forEach(
          function (tab) {
            tab.addEventListener(
              'click',
              function () {
                this.select(tab.dataset.dept, true);
              }.bind(this),
              false
            );
          }.bind(this)
        );
      }

      select(dept, persist) {
        this.showPanel(dept);
        this.highlight(dept);
        if (persist) setCookie(COOKIE, dept);
      }

      showPanel(dept) {
        var shown = false;
        this.panels.forEach(function (panel) {
          var match = panel.dataset.deptPanel === dept;
          panel.hidden = !match;
          if (match) shown = true;
        });
        if (!shown && this.panels[0]) this.panels[0].hidden = false; // safety net
      }

      highlight(dept) {
        this.tabs.forEach(function (tab) {
          var on = tab.dataset.dept === dept;
          tab.classList.toggle('xx-dept-tab--active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }
    }
  );
})();
